if (!customElements.get('collection-quick-filters')) {
  customElements.define(
    'collection-quick-filters',
    class CustomSlider extends HTMLElement {
      constructor() {
        super();
        this.collectionLinks = this.querySelectorAll('[data-collection-link]');
      }

      get id() {
        return this.dataset.id;
      }

      connectedCallback() {
        this.initSlider();
        // this.changesCollectionHandler();
      }

      initSlider() {
        const slider = this.querySelector(`.swiper-${this.id}`);
        if (!slider) return;
        const options = {
          observer: true,
          observeParents: true,
          slidesPerMove: 1,
          grabCursor: true,
          slidesPerView: 'auto',
          spaceBetween: 16,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          watchOverflow: true,
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: this.querySelector('[data-next]'),
            prevEl: this.querySelector('[data-prev]'),
          },
        };

        new Swiper(slider, options);
      }

      changesCollectionHandler() {
        if (this.collectionLinks.length === 0) return;
        this.collectionLinks.forEach((link) => {
          link.addEventListener('click', (event) => this.filterCollection(event, link));
        });
      }

      async filterCollection(event, link) {
        event.preventDefault();
        const url = link.href;
        if (!url) return;

        const response = await fetch(url);
        const result = await response.text();
        const HTML = new DOMParser().parseFromString(result, 'text/html');
        const oldEl = document.querySelector('.shopify-section--main-collection');
        const newEl = HTML.querySelector('.shopify-section--main-collection');
        if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
        history.pushState({}, '', url);
        this.scrollToStart();
      }

      scrollToStart() {
        const collection_container = document.querySelector('.shopify-section--main-collection');
        if (collection_container) {
          const headerHeight = document.querySelector('header').offsetHeight;
          const top = collection_container.offsetTop - this.parentNode.offsetHeight - headerHeight;

          window.scrollTo({
            top: top,
            behavior: 'smooth',
          });
        }
      }
    },
  );
}
